import script from "./ResidentSmetaTreeNode.vue?vue&type=script&setup=true&lang=js"
export * from "./ResidentSmetaTreeNode.vue?vue&type=script&setup=true&lang=js"

import "./ResidentSmetaTreeNode.vue?vue&type=style&index=0&id=3dc0289c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dc0289c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
